/* Original CBD theme JS */
(function () {
  'use strict';

  // ---- Mobile drawer ----
  function initMobileDrawer() {
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    var closeBtn = document.querySelector('[data-mobile-menu-close]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!openBtn || !drawer) return;
    openBtn.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  }

  // ---- Quantity stepper ----
  function initQtySteppers() {
    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      if (!input) return;
      stepper.querySelectorAll('[data-qty-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var action = btn.getAttribute('data-qty-action');
          var current = parseInt(input.value || '1', 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var max = parseInt(input.getAttribute('max') || '99', 10);
          var next = action === 'plus' ? current + 1 : current - 1;
          if (next < min) next = min;
          if (next > max) next = max;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  // ---- AJAX add-to-cart (Shopify) ----
  function initAjaxAddToCart() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Only ajax when Shopify routes exist
        if (typeof window.Shopify === 'undefined') return;
        e.preventDefault();
        var formData = new FormData(form);
        var submit = form.querySelector('button[type="submit"]');
        var originalLabel = submit ? submit.innerHTML : '';
        if (submit) submit.disabled = true;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch(window.Shopify.routes.root + 'cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (submit) {
              submit.innerHTML = '✓ Toegevoegd';
              setTimeout(function () {
                submit.innerHTML = originalLabel;
                submit.disabled = false;
              }, 1400);
            }
          })
          .catch(function () {
            if (submit) {
              submit.disabled = false;
              submit.innerHTML = originalLabel;
            }
          });
      });
    });
  }

  function updateCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  // ---- Contact form fake submit (Shopify form will override server-side) ----
  function initContactForm() {
    var forms = document.querySelectorAll('[data-contact-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        // Shopify processes the {% form 'contact' %} submission natively;
        // no JS needed beyond letting it submit.
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileDrawer();
    initQtySteppers();
    initAjaxAddToCart();
    initContactForm();
  });
})();
